import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { DateRange, FilterSelect, SearchField } from "../../crmpostventa-shared/components/FilterFields";
import { PRIORIDAD_LABELS } from "../../crmpostventa-shared/crmFormat";
import { VISTAS } from "../ipcFilters";
import {
  CANAL_LABELS,
  ESTADO_LABELS,
  ESTADOS_ABIERTOS,
  MOTIVO_LABELS,
  MOTIVOS,
  ORIGEN_LABELS,
  RESULTADOS,
  SECCIONES,
  TIPO_LABELS,
  seccionOf,
  toOptions,
} from "../ipcFormat";

const ESTADO_OPTIONS = toOptions(ESTADO_LABELS, ESTADOS_ABIERTOS);
const RESULTADO_OPTIONS = toOptions(ESTADO_LABELS, RESULTADOS);
const CANAL_OPTIONS = toOptions(CANAL_LABELS, Object.keys(CANAL_LABELS));
const PRIORIDAD_OPTIONS = toOptions(PRIORIDAD_LABELS, ["CRITICA", "ALTA", "MEDIA", "BAJA"]);
const ORIGEN_OPTIONS = toOptions(ORIGEN_LABELS, Object.keys(ORIGEN_LABELS));

// In Todas the motives go grouped by type with "TIPO|CODE" values; in a section, only that section's motives.
const MOTIVO_GROUPS = SECCIONES.filter((seccion) => seccion.value !== "todas").map((seccion) => {
  const key = seccion.tipo || seccion.categoria;
  return {
    label: TIPO_LABELS[key] || seccion.label,
    options: MOTIVOS[key].map((code) => ({ value: `${key}|${code}`, label: MOTIVO_LABELS[code] })),
  };
});

export const FILTER_PANEL_ID = "crm-ipc-filter-panel";

/**
 * FilterBar of the queue (design Prompt 1): search, Motivo with the section's options, Estado (Activas) or
 * Resultado and the close range (Finalizadas), Canal, Prioridad, Responsable, Origen, the "Creada" range and
 * "Limpiar filtros". On mobile only the search and "Filtros (n)" stay visible.
 */
export default function IpcFilterBar({
  vista,
  seccion,
  isMobile,
  searchValue,
  onSearchChange,
  filters,
  onFilterChange,
  responsables,
  today,
  activeCount,
  canClear,
  onClear,
  panelOpen,
  onTogglePanel,
}) {
  const current = seccionOf(seccion);
  const motivoKey = current.tipo || current.categoria;
  const responsableOptions = [
    ...(responsables || []).map((responsable) => ({ value: String(responsable.usuarioId), label: responsable.nombre })),
    { value: "0", label: "Sin asignar" },
  ];
  const finalizadas = vista === VISTAS.FINALIZADAS;

  const selects = (
    <>
      {motivoKey ? (
        <FilterSelect
          name="motivo"
          label="Motivo"
          value={filters.motivo}
          options={MOTIVOS[motivoKey].map((code) => ({ value: code, label: MOTIVO_LABELS[code] }))}
          onChange={onFilterChange}
        />
      ) : (
        <FilterSelect name="motivo" label="Motivo" value={filters.motivo} groups={MOTIVO_GROUPS} onChange={onFilterChange} />
      )}
      {finalizadas ? (
        <FilterSelect name="resultado" label="Resultado" value={filters.resultado} options={RESULTADO_OPTIONS} onChange={onFilterChange} />
      ) : (
        <FilterSelect name="estado" label="Estado" value={filters.estado} options={ESTADO_OPTIONS} onChange={onFilterChange} />
      )}
      <FilterSelect name="canal" label="Canal" value={filters.canal} options={CANAL_OPTIONS} onChange={onFilterChange} />
      <FilterSelect name="prioridad" label="Prioridad" value={filters.prioridad} options={PRIORIDAD_OPTIONS} onChange={onFilterChange} />
      <FilterSelect name="responsable" label="Responsable" value={filters.responsable} options={responsableOptions} onChange={onFilterChange} />
      <FilterSelect name="origen" label="Origen" value={filters.origen} options={ORIGEN_OPTIONS} onChange={onFilterChange} />
      <DateRange label="Creada" fromKey="creadaDesde" toKey="creadaHasta" filters={filters} today={today} onChange={onFilterChange} />
      {finalizadas ? (
        <DateRange label="Cierre" fromKey="cierreDesde" toKey="cierreHasta" filters={filters} today={today} onChange={onFilterChange} />
      ) : null}
    </>
  );

  const clear = (
    <button type="button" className="crm-rollo__link" disabled={!canClear} onClick={onClear}>
      Limpiar filtros
    </button>
  );

  const search = <SearchField label="Buscar por comercio, CUIT o número de comercio" value={searchValue} onChange={onSearchChange} />;

  if (!isMobile) {
    return (
      <div className="crm-rollo__filters">
        {search}
        {selects}
        {clear}
      </div>
    );
  }

  return (
    <div className="crm-rollo__filters">
      {search}
      <button
        type="button"
        className="crm-rollo__btn crm-rollo__btn--secondary"
        aria-expanded={panelOpen}
        aria-controls={FILTER_PANEL_ID}
        onClick={onTogglePanel}
      >
        <FontAwesomeIcon icon={faFilter} aria-hidden="true" />
        {`Filtros${activeCount ? ` (${activeCount})` : ""}`}
      </button>
      {panelOpen ? (
        <div id={FILTER_PANEL_ID} className="crm-rollo__filter-panel">
          {selects}
          <div className="crm-rollo__filter-panel-foot">{clear}</div>
        </div>
      ) : null}
    </div>
  );
}
